import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { detailsUser, updateUser } from '../actions/userActions';
import { AlertMessage } from '../components/AlertMessage'
import { LoadingBox } from '../components/LoadingBox'
import { ToolBar } from '../components/ToolBar';
import { USER_UPDATE_RESET } from '../constants/userConstants';
import Select from "react-select"
import { listStudents } from '../actions/studentActions';
import Swal from 'sweetalert2';
import { getNotificationsUser } from '../actions/notificationActions';

export const UserEditScreen = () => {
    const navigate = useNavigate();
    const params = useParams();
    const userId = params.id;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const [phone, setPhone] = useState('');
    const [dni, setDni] = useState('');
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [address, setAddress] = useState('');

    const [passwordShow, setPasswordShow] = useState(false)
    const [confirmPasswordShow, setConfirmPasswordShow] = useState(false)

    const userDetails = useSelector(state => state.userDetails);
    const { loading, error, user } = userDetails;

    const userUpdate = useSelector(state => state.userUpdate);
    const { loading: loadingUpdate, error: errorUpdate, success: successUpdate } = userUpdate;

    const studentList = useSelector(state => state.studentList);
    const { loading: loadingStudents, error: errorStudents, students } = studentList;


    const dispatch = useDispatch();

    // Select de Usuarios 
    // const options = []
    const [options, setOptions] = useState([])

    const selectedUsers = [];
    const [selectedOptions, setSelectedOptions] = useState([])


    useEffect(() => {
        if (students && !loadingStudents) {
            setOptions([])
            students.map((student) => (
                setOptions(options => [...options, { value: student._id, label: student.name }])
            ))
        }

    }, [students, loadingStudents])

    useEffect(() => {
        if (successUpdate) {
            dispatch({ type: USER_UPDATE_RESET });
            dispatch(detailsUser(userId))
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Padre editado correctamente',
                showConfirmButton: false,
                timer: 1500
            })
        } else {
            if (!user) {
                dispatch(detailsUser(userId))
            }
            else {
                setName(user.name)
                setEmail(user.email)
                setIsAdmin(user.isAdmin)
                setPhone(user.phone)
                setDni(user.dni)
                setCity(user.userAddress?.city)
                setState(user.userAddress?.state)
                setPostalCode(user.userAddress?.postalCode)
                setAddress(user.userAddress?.address)
            }
    }
        dispatch(listStudents())
        dispatch(getNotificationsUser());

    }, [dispatch, user, userId, navigate, successUpdate])


    useEffect(() => {
        if (user) {
            let arrayValores = [];
            user.userChildren.map((child) => (
                arrayValores.push(options.find(option => option.value === child._id))
            ))
            setSelectedOptions(arrayValores);

        }
    }, [user, options])

    const submitHandler = (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            Swal.fire({
                showConfirmButton: true,
                icon: 'error',
                text: 'Las contraseñas no coinciden'
            })
        } else {

            // Añadir objetos de hijos al padre            
            for (const user of students) {
                for (const selectedOption of selectedOptions) {
                    if (user._id === selectedOption.value) {
                        selectedUsers.push(user)
                    }
                }
            }

            dispatch(updateUser({
                _id: userId,
                name,
                email,
                isAdmin,
                password,
                phone,
                userChildren: selectedUsers,
                address,
                city,
                state,
                postalCode,
                dni
            }));
            setPassword('')
            setConfirmPassword('')
        }
    }

    const handleChange = (selectedOptions) => {
        setSelectedOptions(selectedOptions)
    }

    return (
        <>
            <ToolBar titulo={"Editar usuario"} hitos={[
                { titulo: "Inicio", enlace: "/" },
                { titulo: "Usuarios", enlace: "/studentList" },
                { titulo: "Editar usuario", enlace: "#" }]} />
            <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
                <div className="content flex-row-fluid" id="kt_content">
                    <div>
                        {loadingUpdate && <LoadingBox variant={"primary"} />}
                        {errorUpdate && <AlertMessage variant={"danger"} message={errorUpdate} />}
                    </div>
                    {
                        loading ? <LoadingBox variant={"primary"} /> :
                            error ? <AlertMessage variant={"danger"} message={error} /> :
                                <>
                                    <div className="card mb-5 mb-xl-10">
                                        <div className="card-body pt-9 pb-0">
                                            <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                                                <div className="me-7 mb-4">
                                                    <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                                                        <img src="/assets/media/avatars/blank.png" alt="Avatar" />
                                                        <div className="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px"></div>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                                        <div className="d-flex flex-column">
                                                            <div className="d-flex align-items-center mb-2">
                                                                <Link to={"/#"} className="text-gray-900 text-hover-primary fs-2 fw-bolder me-1">{name}</Link>
                                                                <Link to={"/#"}>
                                                                    <span className="svg-icon svg-icon-1 svg-icon-primary">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                            <path d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z" fill="#00A3FF" />
                                                                            <path className="permanent" d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z" fill="white" />
                                                                        </svg>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                            {user.userChildren.length > 0 &&
                                                                <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                                                                    <div className="text-hover-primary fs-3 fw-bolder me-1">Hijos</div>
                                                                    {user.userChildren.map((hijo) => (
                                                                        <div className="col-12" key={hijo.name}>{hijo.name}</div>
                                                                    ))}
                                                                </div>
                                                            }
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card mb-5 mb-xl-10">
                                        <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
                                            <div className="card-title m-0">
                                                <h3 className="fw-bolder m-0">Datos del usuario</h3>
                                            </div>
                                        </div>
                                        <div id="kt_account_settings_profile_details" className="collapse show">

                                            <form autoComplete='off' id="kt_account_profile_details_form" className="form" onSubmit={submitHandler}>
                                                <div className="card-body border-top p-9">
                                                    <h3 className="fw-bolder mx-0 my-5">Datos generales</h3>

                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label required fw-bold fs-6">Nombre</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="name" type="text" placeholder="Introduce el nombre" value={name || ''} onChange={(e) => setName(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label required fw-bold fs-6">Correo electrónico</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="email" type="email" placeholder="Introduce el email" value={email || ''} onChange={(e) => setEmail(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label required fw-bold fs-6">DNI</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="dni" type="text" placeholder="Introduce el dni" value={dni || ''} onChange={(e) => setDni(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label required fw-bold fs-6">Teléfono</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="phone" type="tel" placeholder="Introduce el número de teléfono" value={phone || ''} onChange={(e) => setPhone(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label required fw-bold fs-6">Contraseña</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row position-relative">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" type={passwordShow ? 'text' : 'password'} id="password" value={password || ''} placeholder="Contraseña" onChange={e => setPassword(e.target.value)} />
                                                                    <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2" onClick={() => {setPasswordShow(!passwordShow)}}>
                                                                        {
                                                                        passwordShow 
                                                                        ? <i className="bi bi-eye-slash fs-2"></i>
                                                                        : <i className="bi bi-eye fs-2"></i>
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label required fw-bold fs-6">Confirmar contraseña</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row position-relative">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" type={confirmPasswordShow ? 'text' : 'password'} id="confirmPassword" value={confirmPassword || ''} placeholder="Confirmar contraseña" onChange={e => setConfirmPassword(e.target.value)} />
                                                                    <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2" onClick={() => {setConfirmPasswordShow(!confirmPasswordShow)}}>
                                                                        {
                                                                        confirmPasswordShow 
                                                                        ? <i className="bi bi-eye-slash fs-2"></i>
                                                                        : <i className="bi bi-eye fs-2"></i>
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label required fw-bold fs-6">Hijos</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row">

                                                                    {loadingStudents ? (<LoadingBox variant={"primary"} />) :
                                                                        errorStudents ? (<AlertMessage variant={"danger"} message={errorStudents} />) : (
                                                                            <Select isMulti isClearable options={options} onChange={handleChange} value={selectedOptions || ''} placeholder="Escoja los hijos del usuario" />
                                                                        )}
                                                                    <div className="text-muted fs-7">Escoja uno a uno los padres del alumno. Tambien puede buscarlos escribiendo parte del nombre.</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-6">
                                                        <div className='form-group mt-3'>
                                                            <label className='form-check form-switch form-check-custom form-check-solid'>
                                                                <input className='form-check-input' type='checkbox' checked={isAdmin} onChange={(e) => setIsAdmin(e.target.checked)} />
                                                                <span className='form-check-label fw-bold text-gray-400'>¿Es admin?</span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <h3 className="fw-bolder mx-0 mb-5 mt-10">Datos de dirección</h3>

                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label fw-bold fs-6">Dirección</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="address" type="text" placeholder="Introduce tu dirección" value={address || ''} onChange={(e) => setAddress(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label fw-bold fs-6">Localidad</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="city" type="text" placeholder="Introduce tu localidad" value={city || ''} onChange={(e) => setCity(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label fw-bold fs-6">Provincia</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="state" type="text" placeholder="Introduce tu provincia" value={state || ''} onChange={(e) => setState(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-6">
                                                        <label className="col-lg-4 col-form-label fw-bold fs-6">Código postal</label>
                                                        <div className="col-lg-8">
                                                            <div className="row">
                                                                <div className="col-lg-12 fv-row">
                                                                    <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="postalCode" type="text" placeholder="Introduce tu CP" value={postalCode || ''} onChange={(e) => setPostalCode(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-footer d-flex justify-content-end py-6 px-9">
                                                    <Link to={'/userlist'} className="btn btn-light me-5">Cancelar</Link>
                                                    <button type="submit" className="btn btn-primary" id="kt_account_profile_details_submit">Actualizar usuario</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </>
                    }
                </div>
            </div>
        </>
    )
}
